import React from "react";
import { NotFoundPage } from "./NotFoundPage.js";
import { FrontPage } from "./FrontPage.js";
import { PostsPage } from "../comments/SummariesPage.js";
import { CommentsPage } from "../comments/CommentsPage.js";
import { AuthenticatedRoute } from "../auth/AuthenticatedRoute.js";
import { EntriesPage } from "../accounting/entries/EntriesPage.js";
import { AccountsPage } from "../accounting/accounts/AccountsPage.js";
import { EntryPage } from "../accounting/entry/EntryPage.js";
import { AccountPage } from "../accounting/account/AccountPage.js";
import { EditPage } from "../accounting/entry/EditPage.js";
import { LoginPage } from "../auth/LoginPage.js";
import { CommentPage } from "../comments/CommentPage.js";
import { BrowserHrefProvider } from "../../../packages/router/href/browser/BrowserHrefProvider.js";
import { Router } from "../../../packages/router/router/Router.js";
import { Route } from "../../../packages/router/router/Route.js";
import { AnalyticsPage } from "../analytics/AnalyticsPage.js";
import { AnalyticsFilePage } from "../analytics/AnalyticsFilePage.js";
import { CloudPage } from "../cloud/CloudPage.js";
import { TemplatesPage } from "../templates/TemplatesPage.js";
import { VatReportPage } from "../accounting/vat/VatReportPage.js";
import { AmbrightPage } from "../../model/ambright/AmbrightPage.js";
import { TemplatePage } from "../templates/TemplatePage.js";

/**
 * The application routes.
 */
export const ApplicationRouter = () => {
  return (
    <BrowserHrefProvider>
      <Router fallback={<NotFoundPage />}>
        <Route path="/">
          <FrontPage />
        </Route>
        <Route path="/comments">
          <AuthenticatedRoute>
            <PostsPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/comments/:postId">
          <AuthenticatedRoute>
            <CommentsPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/comment/:commentId">
          <AuthenticatedRoute>
            <CommentPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/entries">
          <AuthenticatedRoute>
            <EntriesPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/accounts">
          <AuthenticatedRoute>
            <AccountsPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/entry/:entryId">
          <AuthenticatedRoute>
            <EntryPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/account/:accountId">
          <AuthenticatedRoute>
            <AccountPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/new">
          <AuthenticatedRoute>
            <EditPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/templates">
          <AuthenticatedRoute>
            <TemplatesPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/template/:templateId">
          <AuthenticatedRoute>
            <TemplatePage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/edit/:entryId">
          <AuthenticatedRoute>
            <EditPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/copy/:copyFromEntryId">
          <AuthenticatedRoute>
            <EditPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/analytics">
          <AuthenticatedRoute>
            <AnalyticsPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/analytics/:file">
          <AuthenticatedRoute>
            <AnalyticsFilePage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/cloud">
          <AuthenticatedRoute>
            <CloudPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/vat">
          <AuthenticatedRoute>
            <VatReportPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/vat/:year/:month">
          <AuthenticatedRoute>
            <VatReportPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/ambright">
          <AuthenticatedRoute>
            <AmbrightPage />
          </AuthenticatedRoute>
        </Route>
        <Route path="/login">
          <LoginPage />
        </Route>
      </Router>
    </BrowserHrefProvider>
  );
};
